import apiBase from "../../api/axios";

export const getUsersService = async (
  page = 1,
  search = "",
  escuela = null,
  plantel = null,
) => {
  let url = `v1/usuarios/?page=${page}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  if (escuela !== null) url += `&escuela=${escuela}`;
  if (plantel !== null) url += `&plantel=${plantel}`;
  const response = await apiBase.get(url);
  return response.data;
};

export const createUserService = async (payload) => {
  const response = await apiBase.post("v1/usuarios/", payload);
  return response.data;
};

export const getUserByIdService = async (id) => {
  const response = await apiBase.get(`v1/usuarios/${id}/`);
  return response.data;
};

export const updateUserService = async (id, payload) => {
  const response = await apiBase.patch(`v1/usuarios/${id}/`, payload);
  return response.data;
};

export const toggleUserActiveService = async (id, isActive) => {
  const response = await apiBase.post(`v1/usuarios/${id}/toggle_active/`, {
    is_active: isActive,
  });
  return response.data;
};

export const getEscuelasSelectorService = async (search = "") => {
  let url = "v1/escuela/selectores/";
  if (search) url += `?search=${encodeURIComponent(search)}`;
  const response = await apiBase.get(url);
  return response.data;
};

export const getPlantelesByEscuelaService = async (escuelaId, search = "") => {
  let url = `v1/plantel/selectores/?escuela=${escuelaId}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  const response = await apiBase.get(url);
  return response.data;
};
